import { render } from "./RfpMeasures.vue?vue&type=template&id=b0a06aea&scoped=true&ts=true"
import script from "./RfpMeasures.vue?vue&type=script&lang=ts"
export * from "./RfpMeasures.vue?vue&type=script&lang=ts"

import "./RfpMeasures.vue?vue&type=style&index=0&id=b0a06aea&lang=postcss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0a06aea"]])

export default __exports__